export const sumByKey = (arr, key) => arr.reduce((acc, curr) => acc + (Number(curr[key]) || 0), 0);

export const getMaxValueByKey = (arr, key) =>
  arr.reduce((prev, curr) => {
    return prev < curr?.[key] ? Number(curr[key]) : prev;
  }, 0);
